export default __webpack_public_path__ + "static/patamedslogo-7f34050e8dd900805455142fd31da176.svg";